export const DELETE_TASK_SUCCESS = "Task deleted!";
export const DELETE_TASK_FAILURE = "Could not delete task";
export const UPDATE_TASK_SUCCESS = "Task updated!";
export const UPDATE_TASK_FAILURE = "Could not update task";
